import React, { useState } from "react";
import moment from "moment";
import Button from "../../../../shared/button";
import {
  useGetAllDraftsEmailMutation,
  useGetOutlookCredentialsQuery,
} from "../../../../store/google-reservations/googleReservationsApi";
import { useGetCurrentAuthUrlQuery } from "../../../../store/reservations/reservationsApi";

const SummaryEmailTable = () => {
  const [summaryText, setSummaryText] = useState<string>();
  const { data: authUrl } = useGetCurrentAuthUrlQuery({});

  const { data: outlookCredentials } = useGetOutlookCredentialsQuery();

  const [getAllDraftsEmail, { isLoading, data }] =
    useGetAllDraftsEmailMutation();

  const handleGetAllReservations = async () => {
    const accessToken = outlookCredentials?.accessToken;
    if (accessToken) {
      const res = await getAllDraftsEmail(accessToken || "").unwrap();
      setSummaryText(res.message || res.toString());
    } else {
      window.location.assign(authUrl.authUrl);
    }
  };

  return (
    <div className="bg-white p-4">
      <h2 className="text-[#5D6679] text-base mb-2">Summary E-mails</h2>
      <div className="bg-[#F9F9F9] rounded-lg px-4 py-6">
        <div className="flex flex-row items-center">
          <img src="/assets/shared/email.svg" alt="" />
          <div className="ml-3">
            <p className="text-[#161048] text-xs">
              Last Processing -{" "}
              {typeof data?.date === "object" && moment(data?.date).fromNow()}
            </p>
            <h4 className="text-[#202020] text-base font-bold">New Emails</h4>
            <p className="text-primary-default text-base">
              {data?.totalEmailsProcessed}
            </p>
          </div>
        </div>
        <Button
          icon={
            <img
              alt="review"
              className="mr-2"
              src="/assets/shared/reviewt.svg"
            />
          }
          onClickButton={handleGetAllReservations}
          label="Review Drafts Emails"
          loading={isLoading}
          className="mt-3 bg-primary-default rounded-xl py-2 px-4 text-white flex flex-row items-center text-sm md:tex-base"
        />
        <p className="text-sm mt-2">{summaryText}</p>
      </div>
    </div>
  );
};

export default SummaryEmailTable;
